import React from 'react';
import { CheckCircle2, ChefHat, ShoppingBag, XCircle } from 'lucide-react';
import { formatNumber } from '../utils/kpiFormatters';
import type { KpiOrderLifecycleStage } from '../types';

interface Props {
  stages: KpiOrderLifecycleStage[];
  totalCreated: number;
}

const ICONS: Record<string, React.ReactNode> = {
  created: <ShoppingBag size={16} className="text-sky-600" />,
  kitchen: <ChefHat size={16} className="text-amber-600" />,
  completed: <CheckCircle2 size={16} className="text-emerald-600" />,
  cancelled: <XCircle size={16} className="text-rose-600" />,
};

export const OrderCycleFunnel: React.FC<Props> = ({ stages, totalCreated }) => {
  if (!stages || stages.length === 0 || totalCreated === 0) {
    return (
      <div className="py-8 text-center text-xs text-text-muted">
        Sin pedidos registrados en este periodo
      </div>
    );
  }

  return (
    <div className="space-y-3 py-1">
      {stages.map((stage) => {
        const isCancelled = stage.key === 'cancelled';
        const barColor = isCancelled ? 'bg-rose-500' : 'bg-emerald-600';

        return (
          <div
            key={stage.key}
            className="p-3 rounded-xl border border-border bg-background/50 space-y-1.5"
          >
            <div className="flex items-center justify-between gap-2 text-xs">
              <div className="flex items-center gap-2">
                <span className="p-1.5 rounded-lg bg-surface border border-border">
                  {ICONS[stage.key] || <ShoppingBag size={16} />}
                </span>
                <div>
                  <p className="font-bold text-text">{stage.label}</p>
                  <p className="text-[11px] text-text-muted">{stage.description}</p>
                </div>
              </div>

              <div className="text-right">
                <span className="text-sm font-black text-text">
                  {formatNumber(stage.count)}
                </span>
                <p className="text-[10px] font-bold text-text-muted">
                  {stage.conversion.toFixed(1)}% {isCancelled ? 'tasa cancelación' : 'del total'}
                </p>
              </div>
            </div>

            {/* Barra de progreso */}
            <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
              <div
                className={`h-full rounded-full transition-all duration-500 ${barColor}`}
                style={{ width: `${Math.min(100, Math.max(2, stage.conversion))}%` }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};
